import { ITreeNode } from './Itree-node';
import { getWrappedTreeNodes } from './helpers/tree-node-helpers';
export class TreeNodeWrapper implements ITreeNode {
	constructor(treeNode: ITreeNode) {
		(this.wrappedNode = treeNode),
			(this.id = treeNode.id),
			(this.text = treeNode.text),
			(this.isSelected = treeNode.isSelected),
			(this.isEditable = treeNode.isEditable),
			(this.isOpened = treeNode.isOpened),
			(this._isVisible = treeNode.isVisible),
			(this.isHighlighted = treeNode.isHighlighted),
			(this.children = getWrappedTreeNodes(treeNode.children)),
			(this.tooltip = treeNode.tooltip),
			(this.parentId = treeNode.parentId);
	}
	id: number | string;
	text: string;
	disableDragAndDrop?: boolean | undefined;
	isSelected: boolean;
	isEditable: boolean;
	isOpened: boolean;
	tooltip?: string;

	private _isVisible: boolean;
	get isVisible(): boolean {
		return this._isVisible;
	}
	set isVisible(value: boolean) {
		if (value && !this.wrappedNode.isVisible) return;

		this._isVisible = value;
	}

	isHighlighted: boolean;
	children: ITreeNode[];
	parentId: number | string | null;
	public wrappedNode: ITreeNode;
}
